// components/TourLauncher.tsx
import React from "react";
import { useTour } from "../../context/TourContext";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Btn, H4 } from "../../AbstractElements";
import { useDispatch } from "react-redux";
import { setShowTourModel, setSideBarToggle } from "../../ReduxToolkit/Reducers/Layout/LayoutReducer";
import { useSelector } from "react-redux";

export const TourLauncher = () => {

  const { startTour, resetTour } = useTour();
  const dispatch = useDispatch();

  const showTour=useSelector((state: any) => state.layout.showTourModel);
  // alert("showTour value in TourLauncher component: " + showTour);

  // const [showTour, setShowTour] = React.useState<boolean>(localStorage.getItem("app_tour_shown_v1") != "true");


  const startTourProcess = () => {
    // setShowTour(false);
    dispatch(setShowTourModel(false));
    dispatch(setSideBarToggle(false));

    setTimeout(() => {
      startTour();
    }, 3000);

  }
  return (
    <>
      <Modal
        isOpen={showTour}
        toggle={() => { dispatch(setShowTourModel(!showTour)) }}
        centered
        className="modal-dialog-centered"
      >
        <ModalHeader toggle={() => { dispatch(setShowTourModel(false));localStorage.setItem("app_tour_shown_v1", "true") }} className="bg-light text-dark">
          <H4 className="mb-2 text-dark"> Welcome aboard! </H4>
        </ModalHeader>
        <ModalBody>

          <div className="py-2">

            <p className="mn-1 text-dark">
              Let’s take a quick tour so you can get familiar with everything here.
            </p>
            {/* <button onClick={startTour}>Start Tour</button>
          <button onClick={resetTour}>Reset Tour (show again next visit)</button> */}
          </div>
        </ModalBody>

        <ModalFooter>
          <div className="d-flex" style={{ gap: 8 }}>
            <Btn color="light text-dark" onClick={() => { dispatch(setShowTourModel(false)); localStorage.setItem("app_tour_shown_v1", "true") }}>Cancel</Btn>
            <Btn color="danger" onClick={startTourProcess}>
              Start Tour
            </Btn>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};
